/* On production we use the sst foldder (server side tracking)
  This file is for debugging the tag manager in local mode where it appends the google tag manager script to the head and we
  can look at the _ddm events.
*/

export default defineNuxtPlugin(({ $config }) => {
  const { public: publicConfig } = $config;

  if (publicConfig.localAnalyticsMode) {
    console.log(
      "%cLocal analytics mode is enabled 🧙",
      "background-color: lightgreen; color: darkgreen; padding: 5px 10px; border-radius: 3px;",
    );

    useHead({
      script: [
        {
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${publicConfig.debuggingAnalyticsId}');`,
          tagPosition: "head",
        },
      ],
    });
  }
});
